import type { TLocalStorageKeys } from '~/features/store/ELocalStorageKeys';
import { useLocalStorage } from '@vueuse/core';

export function useLocalStorageNoChanges<T>(key: TLocalStorageKeys, defaultValue: T) {
  return useLocalStorage<T>(key, defaultValue, {
    listenToStorageChanges: false,
    writeDefaults: true,
  });
}
